var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"restaurantBookSet"},[_c('div',{staticClass:"title"},[_c('div',[_vm._v(_vm._s(_vm.$route.meta.title))])]),_c('wholeVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }